// AUKUS Supply Chain inner page — Defence Card 01.
import { ArrowRight } from "lucide-react";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import InnerHero from "../../components/InnerHero";
import Reveal from "../../components/Reveal";
import { VIDEOS } from "../../lib/media";

export default function AukusSupplyChain() {
  return (
    <div className="bg-black">
      <Nav route="inner" />
      <InnerHero
        video={VIDEOS.submarine}
        eyebrow="Defence · Submarines and AUKUS"
        headline="Sovereign capability for the"
        italicWord="AUKUS supply chain."
        lede="We help AU and NZ businesses enter and sustain their position in the AUKUS submarine and naval programme supply chain."
      />

      <section className="bg-black py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6">

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">What this is</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              Getting in is hard. Staying in is harder.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              AUKUS imposes strict security, export-control and personnel-screening requirements on
              every vendor in the supply chain. Most businesses underestimate the compliance burden
              until they receive a supplier questionnaire they cannot answer.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              We provide the audits, AI-generated policy packs and software tools that give your
              procurement contact confidence you are ready to operate in a cleared environment.
            </p>
          </Reveal>

          <div className="hairline my-16" />

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">How we work</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              Audit, policy, software: in that order.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              We start with a full defence-readiness audit mapped to AUKUS export-control obligations,
              Essential Eight and relevant DISP requirements. You get a scored report and a
              remediation plan.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              We then generate the policy suite your supply-chain position requires and, where
              relevant, build the software systems that enforce and evidence your compliance posture
              on an ongoing basis.
            </p>
          </Reveal>

          <div className="hairline my-16" />

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">Right for you if</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              You are entering or expanding in the AUKUS programme.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              You supply components, services or technology to a prime contractor or directly to
              Defence. You have received a security assessment request and need to respond credibly.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              You are an AU or NZ business in manufacturing, technology, professional services or
              resources looking to diversify into defence work under the AUKUS framework.
            </p>
          </Reveal>

        </div>
      </section>

      <section className="bg-black px-6 pb-24">
        <div className="max-w-2xl mx-auto liquid-glass rounded-3xl p-10 text-center">
          <h3 className="font-instrument text-3xl text-white">Ready to build something that lasts?</h3>
          <p className="text-white/60 text-base mt-4">
            Start with a 30-minute discovery call. No slide deck. Just an engineer.
          </p>
          <a
            href="/#contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full px-8 py-3 bg-white text-black text-sm font-medium hover:bg-white/90 transition-colors"
          >
            Book a discovery <ArrowRight size={16} />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
